import { isNuxtLink } from './type-validators'

/**
 * @param {object} vnode the vnode to clone
 * @returns {object} the cloned vnode
 */
export function cloneVNode(vnode) {
  const cloned = new vnode.constructor(
    vnode.tag,
    vnode.data,
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  )
  cloned.ns = vnode.ns
  cloned.isStatic = vnode.isStatic
  cloned.key = vnode.key
  cloned.isComment = vnode.isComment
  cloned.fnContext = vnode.fnContext
  cloned.fnOptions = vnode.fnOptions
  cloned.fnScopeId = vnode.fnScopeId
  cloned.asyncMeta = vnode.asyncMeta
  cloned.isCloned = true
  return cloned
}

/**
 * Turns first character of a string to a capital version
 * @param {string} string to capitalize
 * @returns {string} capitalised string
 */
export function capitaliseFirstLetter(string) {
  if (typeof string !== 'string') return ''
  return string.charAt(0).toUpperCase() + string.slice(1)
}

/**
 * Promisifies setTimeout
 * @param {number} ms time to wait in milliseconds
 * @returns {Promise} the timeout promise
 */
export function timeout(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

/**
 * Returns the correct link attributes based on the link provided
 * @param {object} $attrs current attributes of the link
 * @param {string} tag the component element tag
 * @returns {object} the attributes object
 */
export function getLinkAttrs($attrs, tag) {
  // Dynamic components in nuxt 3 have to be passed as a resolved component object
  // https://nuxt.com/docs/guide/directory-structure/components#dynamic-components
  if ($attrs.href && (tag === 'router-link' || isNuxtLink(tag))) {
    // Replace href attribute if it's an internal link
    const { href, ...attrs } = $attrs
    return { to: href, ...attrs }
  } else {
    return $attrs
  }
}
